import { Timer } from 'lucide-react'
import { withTooltip } from '../../withTooltip'

export const WaitingTimer = withTooltip(
  Timer,
  'Waiting for other transactions to end'
)

export * from './Indicators'
